import type { BookmarkIntent, IntentClassificationData } from './types';

export const isBookmarkIntent = (intent: IntentClassificationData): intent is BookmarkIntent =>
	intent.__typename === 'KnowledgeDiscoveryBookmarkIntent';
